import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-arrow-drop-down-icon',
  templateUrl: 'arrow-drop-down-icon.component.html'
})
export class ArrowDropDownIconComponent {
  constructor() {}
}
